import React, { createContext, useEffect, useState } from 'react'

export const themeContext = createContext()
export default function ThemeContextProvider(props) {
    let [webtheme, settheme] = useState("light")

    useEffect(() => {
        let theme = localStorage.getItem('theme');
        if (theme) {
            settheme(theme)
        }
    }, [])
    const setThemeStorage = (theme) => {
        settheme(theme)
        localStorage.setItem('theme', theme)
    }
    let changeThemeTo = (theme) => {
        theme == 'dark' ? setThemeStorage('dark') : setThemeStorage('light');
    }
    return (
        <themeContext.Provider value={{ webtheme, changeThemeTo }}>
            {props.children}
        </themeContext.Provider>
    )
}
